import { Box, Grid, Text, useTheme } from '@simplywallst/ui-core';
import SnowflakeConfig from '../SnowflakeConfig';
import GlobeOutline from '@simplywallst/ui-core/icons/GlobeOutline';
import IndustryOutline from '@simplywallst/ui-core/icons/IndustryOutline';
import FilterOutline from '@simplywallst/ui-core/icons/FilterOutline';

import { KeywordSearch } from './components/KeywordSearch';
interface Props {
  snowflakeScore: number[];
  onSnowflakeChange: (points: number[]) => void;
  onShowMarketModal: () => void;
  onShowIndustryModal: () => void;
  onShowFiltersModal: () => void;
  keywords?: string;
  onKeywordChange: (keywords: string) => void;
  selectedMarkets: string[];
  selectedIndustries: string[];
  selectedFilters: string[];
}
export function Filters({
  snowflakeScore,
  onSnowflakeChange,
  onShowMarketModal,
  onShowIndustryModal,
  onShowFiltersModal,
  onKeywordChange,
  keywords,
  selectedMarkets,
  selectedIndustries,
  selectedFilters,
}: Props) {
  const theme = useTheme();
  const [firstMarket, ...restMarkets] = selectedMarkets;
  const [firstIndustry, ...restIndustry] = selectedIndustries;

  function getFilterLabels() {
    const [firstFilter, ...restFilters] = selectedFilters;
    if (firstFilter.toLowerCase() === 'hide secondary listings') {
      if (restFilters.length === 0) {
        return ['', []] as const;
      } else {
        const [firstRestFilters, ...restRestFilters] = restFilters;
        return [firstRestFilters, restRestFilters] as const;
      }
    }
    return [firstFilter, restFilters] as const;
  }
  const [firstFilter, restFilters] = getFilterLabels();

  function createFilterLabel(
    firstItem?: string,
    restItems?: readonly string[],
    type: 'market' | 'industry' | 'filter' = 'filter'
  ) {
    let sentence = '';
    if (typeof firstItem === 'string') {
      sentence = firstItem;
    }
    if (typeof restItems !== 'undefined' && restItems.length > 0) {
      sentence += `, +${restItems.length} more`;
    }
    if (sentence !== '') {
      return sentence;
    } else {
      if (type === 'market') {
        return 'All markets';
      } else if (type === 'industry') {
        return 'All industries';
      } else {
        return `No filters selected`;
      }
    }
  }
  return (
    <Box
      paddingLeft="x3spacePx"
      paddingRight="x3spacePx"
      paddingLeftMd="x0spacePx"
      paddingRightMd="x0spacePx"
    >
      <Grid
        gap="10px"
        templateRows="1fr 1fr 1fr"
        templateRowsMd="1fr"
        templateColumns="3fr 1fr"
        templateColumnsMd="1.5fr 1fr 1fr 1fr"
      >
        <Grid row="span 3" rowMd="span 1">
          <Box
            boxShadow="subtleBorder"
            backgroundColor="noir"
            borderRadius="x1spacePx"
            padding="x1spacePx"
          >
            <Text typography="tinyStrong">Snowflake</Text>
            <SnowflakeConfig
              score={snowflakeScore}
              onChange={onSnowflakeChange}
            />
          </Box>
        </Grid>
        <Grid column="2">
          <Box
            boxShadow="subtleBorder"
            backgroundColor="noir"
            borderRadius="x1spacePx"
            padding="x1spacePx"
            onClick={onShowMarketModal}
            style={{ cursor: 'pointer' }}
          >
            <GlobeOutline width={theme.x3spacePx} height={theme.x3spacePx} />
            <Text typography="tinyStrong">Markets</Text>
            <Text typography="tiny" color="brand03">
              {createFilterLabel(firstMarket, restMarkets, 'market')}
            </Text>
          </Box>
        </Grid>
        <Grid column="2" columnMd="3">
          <Box
            boxShadow="subtleBorder"
            backgroundColor="noir"
            borderRadius="x1spacePx"
            padding="x1spacePx"
            onClick={onShowIndustryModal}
            style={{ cursor: 'pointer' }}
          >
            <IndustryOutline
              fill={theme.color.white}
              width={theme.x3spacePx}
              height={theme.x3spacePx}
            />
            <Text typography="tinyStrong">Industry</Text>
            <Text typography="tiny" color="brand03">
              {createFilterLabel(firstIndustry, restIndustry, 'industry')}
            </Text>
          </Box>
        </Grid>
        <Grid column="2" columnMd="4">
          <Box
            boxShadow="subtleBorder"
            backgroundColor="noir"
            borderRadius="x1spacePx"
            padding="x1spacePx"
            onClick={onShowFiltersModal}
            style={{ cursor: 'pointer' }}
          >
            <FilterOutline
              fill={theme.color.white}
              width={theme.x3spacePx}
              height={theme.x3spacePx}
            />
            <Text typography="tinyStrong">Metrics</Text>
            <Text typography="tiny" color="brand03">
              {createFilterLabel(firstFilter, restFilters, 'filter')}
            </Text>
          </Box>
        </Grid>
      </Grid>
      <KeywordSearch keywords={keywords} onChange={onKeywordChange} />
    </Box>
  );
}
